var map = {
	"./Asset.json": 92730,
	"./Fund.json": 10773,
	"./FundSeries.json": 57684,
	"./Manager.json": 83781,
	"./Market.json": 83654,
	"./MarketBlended.json": 60904,
	"./Portfolio.json": 42742,
	"components/config/dashboard-templates/Templates/Asset.json": 92730,
	"components/config/dashboard-templates/Templates/Fund.json": 10773,
	"components/config/dashboard-templates/Templates/FundSeries.json": 57684,
	"components/config/dashboard-templates/Templates/Manager.json": 83781,
	"components/config/dashboard-templates/Templates/Market.json": 83654,
	"components/config/dashboard-templates/Templates/MarketBlended.json": 60904,
	"components/config/dashboard-templates/Templates/Portfolio.json": 42742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72006;